<template>

  <div class="flex pt-2 align-top">
    <span class="block text-sm text-center m-0 uppercase">{{ column.label }}</span>
    <div v-if="!isDaily || (isDaily && !isGroupAndPastDay)" class="mx-1">
      <ul class="w-full list-none pl-0 relative">
        <PlannerItemDesktop v-for="item in column.items" :key="item.id" :session="item" />
      </ul>
    </div>
  </div>
</template>

<script setup>
import { defineProps, inject, ref, computed } from 'vue';
import PlannerItemDesktop from './PlannerItemDesktop.ce.vue';

defineProps({
  column: {
    type: Object,
    default: () => ({})
  },
  isDaily: {
    type: Boolean,
    default: false
  },
  isGroupAndPastDay: {
    type: Boolean,
    default: false
  }
});

// Get byMonths from parent component via inject
const byMonthsValue = inject('byMonths', ref(false));
const byMonths = computed(() => byMonthsValue.value);
</script>
